import React from 'react'
import Logo from "../../../Reutilizables/Logo"
import MenuServicios from "../Menu_servicios"
import Redes from "../../../Reutilizables/Redes"
import TituloImpuestosMunicipales from "../../../Reutilizables/TituloImpuestosMunicipales"

function Predial_unificado() {
  return (
    <>
      <div className='container-logo-menu'>
        <Logo />
        <MenuServicios />
      </div>
      <div className='tittle-menu-servicios'>
        <TituloImpuestosMunicipales />
      </div>
      <Redes />
    </>
  )
}

export default Predial_unificado